import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    leftMenu: [],
    privilegeIds: [],
    orderReminder: {
      enabled: localStorage.getItem('orderReminderEnabled') === 'true',
      lastOrderId: null,
      intervalId: null
    }
  },
  getters: {
    leftMenu: state => {
      return state.leftMenu;
    },
    privilegeIds: state => {
      return state.privilegeIds;
    },
    orderReminder: state => {
      return state.orderReminder;
    }
  },
  mutations: {
    leftMenu: (state, config) => {
      state.leftMenu = config;
    },
    privilegeIds: (state, config) => {
      state.privilegeIds = config;
    },
    setOrderReminderEnabled: (state, enabled) => {
      state.orderReminder.enabled = enabled;
      localStorage.setItem('orderReminderEnabled', enabled.toString());
    },
    setLastOrderId: (state, orderId) => {
      state.orderReminder.lastOrderId = orderId;
    },
    setReminderIntervalId: (state, intervalId) => {
      state.orderReminder.intervalId = intervalId;
    }
  },
});


export default store;



// WEBPACK FOOTER //
// ./src/config/store.js